// extracted by mini-css-extract-plugin
export default {"dark":"BtnForms_dark__MwQv5","App":"BtnForms_App__Cgs7v","login__submit":"BtnForms_login__submit__vQc+8"};